import { RepaymentLoans } from "components/Dashboard/Repayment";
import DashboardHeader from "components/Dashboard/shared/DashboardHeader";
import MainLayout from "layout/MainLayout";

export default function RepaymentPage(){
    return(
        <MainLayout>
           <DashboardHeader title="Repayment History" back/>
           <div className="px-4 py-10">
            <RepaymentLoans/>
           </div>
        </MainLayout>
    )
}